/**
 * ListingShare
 * 
 * @Author: Focci
 * @Date: 2024-02-20 14:31:04
 * @Last Modified by: Focci
 * @Last Modified time: 2024-02-20 14:31:04
 */

'use client'

import SVGShare from '@img/share.svg'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'

const Share = dynamic(() => import('@comp/share'), {
  ssr: false,
  loading: () => <ShareButton />
})

function ShareButton() {
  const tc = useTranslations('common')
  
  return (
    <div className="flex items-center gap-1">
      {tc('share')}
      <SVGShare width=".7rem" />
    </div>
  )
}

export default function ListingShare() {
  return (
    <Share 
      trigger={<ShareButton />}
    />
  )
}
